import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import wallClockIcon from '../../images/wall-clock.svg'
import UseTranslation from '../../hooks/UseTranslation'

const TimerBtn = ({ title, onClick, customStyle }) => {
  const [countdown, setCountdown] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const { t } = UseTranslation()

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else {
      setIsDisabled(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const handleClick = () => {
    onClick();
    setIsDisabled(true);
    setCountdown(10);
  };

  return (
    <Button
      onClick={handleClick}
      disabled={isDisabled}
      sx={[styles.root, customStyle]}
    >
      {isDisabled ? <Box sx={styles.timer}>
            <Box component={'img'} src={wallClockIcon} alt='wallClockIcon'/> {countdown} {t?.s}
      </Box> : <Box component={'span'}> {title || `${t?.Refresh}`} </Box>}
    </Button>
  )
}

const styles = {
  root: {
    height: '40px',
    width: '130px',
    fontSize: '16px',
    color: '#FFF',
    backgroundColor: 'primary.main',
    textTransform: 'initial',
    borderRadius: '10px',
    '&.Mui-disabled': {
      backgroundColor: 'primary.main',
      color: '#FFF',
    },

    '&:hover': {
      color: 'white',
      backgroundColor: 'primary.main',
    },
  },
  timer: { display: 'flex', alignItems: 'center', gap: '3px', justifyContent: 'center' },
}
export default TimerBtn
